/*@ngInject*/
const UIShowFieldDetailsModalDirective = function (formMediator, modalUtil) {

    let linkFunction = function ($scope, $elm, $attr) {

        let element = $($elm),
            rootFormId = $scope.fieldStructure.rootFormId;

        function showFieldDetailsModal(event) {
            if (event.shiftKey && (event.ctrlKey || event.altKey)) {
                modalUtil.showFieldDetails($scope.fieldStructure, formMediator.getFormStructure(rootFormId));
            }
        }

        element.bind('click', showFieldDetailsModal);

        $scope.$on('$destroy', function () {
            element.unbind('click', showFieldDetailsModal);
        });
    };

    return {
        restrict: 'A',
        link: linkFunction
    };
};

angular.module('umFormViewer')
    .directive('uiShowFieldDetailsModal', UIShowFieldDetailsModalDirective);
